import { useEffect, useState } from "react";
import "./navbar.css";

export default function Navbar({ logo, t, language, setLanguage }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <a href="#top" className="navbar-brand" aria-label="Matneu Investment">
        <img src={logo} alt="Matneu Investment" />
      </a>

      <nav className="navbar-menu">
        <a href="#services">{t.navServices}</a>
        <a href="#about">{t.navAbout}</a>
        <a href="#contact">{t.navContact}</a>
      </nav>

      <div className="nav-right">
        <div className="lang-switch">
          <button
            type="button"
            onClick={() => setLanguage("en")}
            className={language === "en" ? "active" : ""}
          >
            EN
          </button>

          <button
            type="button"
            onClick={() => setLanguage("es")}
            className={language === "es" ? "active" : ""}
          >
            ES
          </button>
        </div>

        <a className="nav-btn" href="#contact">
          {t.navButton}
        </a>
      </div>
    </header>
  );
}